import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from 'Components/UI/PageHeader/PageHeader';
import { Collapse, Row, Col } from 'antd';
import BreadCrumb, { IBreadcrumbItem } from 'Components/UI/BreadCrumb';
import { Icon } from 'Components/UI';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { connect, ConnectedProps } from 'react-redux';
import MockPapeisPermissoes from './mockPapeisPermissoes.json';
import LogoPapeisPermissoes from 'Static/images/logo-papeis-permissoes.png';
import styles from './PapeisPermissoes.module.scss';
import './PapeisPermissoes-override.css';

interface IDadosPapeisPermissoes {
  title: string;
  admin: {
    hasPermission: string | boolean;
    marked: boolean;
  };
  coordernador: {
    hasPermission: string | boolean;
    marked: boolean;
  };
  engenheiro: {
    hasPermission: string | boolean;
    marked: boolean;
  };
  projetista: {
    hasPermission: string | boolean;
    marked: boolean;
  };
  consultor: {
    hasPermission: string | boolean;
    marked: boolean;
  };
}

const { Panel } = Collapse;

const PapeisPermissoes: FC<Props> = () => {
  const { t } = useTranslation('gerenciarUsuarios');

  const breadCrumbs: IBreadcrumbItem[] = [
    {
      description: t('papeisPermissoes.breadcrumbRoot'),
      href: '/gerenciar-usuarios/usuarios'
    },
    {
      description: t('papeisPermissoes.breadcrumb'),
      href: '/gerenciar-usuarios/papeis'
    }
  ];

  return (
    <div className={styles['hearderPage']}>
      <PageHeader name={t('papeisPermissoes.pageTitle')}>
        <div className={styles['breadCrumb']}>
          <BreadCrumb breadcrumbs={breadCrumbs} />
        </div>
        <div className={styles['infoPapelContainer']}>
          <div className={styles['containerPapeisPermissoes']}>
            <img src={LogoPapeisPermissoes} alt={t('papeisPermissoes.logoAlt')} />
          </div>
          <div className={styles['text']}>
            <h2>{t('papeisPermissoes.sectionTitle')}</h2>
            <h3>
              {t('papeisPermissoes.sectionDescription')}
            </h3>
            {/* <h3>
              <b>Ainda tem dúvidas?</b> Leia o artigo sobre{' '}
              <b>"Como alterar as permissões de um usuário?"</b> no menu Ajuda.
            </h3> */}
          </div>
        </div>
        <Row gutter={[16, 16]} className={styles['headerPapelContainer']}>
          <Col span={6} style={{ padding: '8px 8px 8px 36px', textAlign: 'left' }}>
            <b>{t('papeisPermissoes.headerPermissions')}</b>
          </Col>
          <Col span={2}>
            <b>{t('papeisPermissoes.headerAdmin')}</b>
          </Col>
          <Col span={4}>
            <b>{t('papeisPermissoes.headerCoordenador')}</b>
          </Col>
          <Col span={4}>
            <b>{t('papeisPermissoes.headerProjetista')}</b>
          </Col>
          <Col span={4}>
            <b>{t('papeisPermissoes.headerEngenheiro')}</b>
          </Col>
          <Col span={4}>
            <b>{t('papeisPermissoes.headerConsultor')}</b>
          </Col>
        </Row>
        <div className={styles['pageContainer']}>
          <>
            {MockPapeisPermissoes.modulos.map((modulo: any) => (
              <div className={styles['containerCollapse']}>
                <Collapse
                  expandIconPosition={'right'}
                  style={{ backgroundColor: 'white', border: '1px solid #EAEDF0' }}
                  bordered={false}
                >
                  <Panel
                    header={
                      <div className={styles['panelContainer']}>
                        <Icon
                          icon={modulo.icon}
                          className={styles['iconTablePapeisPermissoes']}
                          customSize={18}
                        />
                        {t(modulo.nomeModulo)}
                      </div>
                    }
                    style={{ padding: '0px' }}
                    key={modulo.index}
                  >
                    {modulo.data.map((infoModulo: IDadosPapeisPermissoes, index: any) => (
                      <Row
                        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                        className={
                          index % 2 === 0 ? styles['indexGray'] : styles['indexWhite']
                        }
                        justify="space-between"
                      >
                        <Col className={styles['rowTitleContainer']} span={6}>
                          <div className={styles['title']}>{t(infoModulo.title)}</div>
                        </Col>
                        <Col className={styles['rowDataContainer']} span={2}>
                          {typeof infoModulo.admin.hasPermission === 'string' ? (
                            <div
                              className={
                                infoModulo.admin.marked
                                  ? styles['rowDataMarked']
                                  : styles['rowDataUnMarked']
                              }
                            >
                              {t(infoModulo.admin.hasPermission as string)}
                            </div>
                          ) : (
                            <>
                              {infoModulo.admin.hasPermission === true ? (
                                <Icon
                                  icon={'confirmar'}
                                  className={
                                    infoModulo.admin.marked
                                      ? styles['rowIconMarked']
                                      : styles['rowIconUnMarked']
                                  }
                                  customSize={12}
                                />
                              ) : (
                                <Icon
                                  icon={'cancelar'}
                                  className={
                                    infoModulo.admin.marked
                                      ? styles['rowIconMarked']
                                      : styles['rowIconUnMarked']
                                  }
                                  customSize={12}
                                />
                              )}
                            </>
                          )}
                        </Col>
                        <Col className={styles['rowDataContainer']} span={4}>
                          {typeof infoModulo.coordernador.hasPermission === 'string' ? (
                            <div
                              className={
                                infoModulo.coordernador.marked
                                  ? styles['rowDataMarked']
                                  : styles['rowDataUnMarked']
                              }
                            >
                              {t(infoModulo.coordernador.hasPermission as string)}
                            </div>
                          ) : (
                            <>
                              {infoModulo.coordernador.hasPermission === true ? (
                                <Icon
                                  icon={'confirmar'}
                                  className={
                                    infoModulo.coordernador.marked
                                      ? styles['rowIconMarked']
                                      : styles['rowIconUnMarked']
                                  }
                                  customSize={12}
                                />
                              ) : (
                                <Icon
                                  icon={'cancelar'}
                                  className={
                                    infoModulo.coordernador.marked
                                      ? styles['rowIconMarked']
                                      : styles['rowIconUnMarked']
                                  }
                                  customSize={12}
                                />
                              )}
                            </>
                          )}
                        </Col>
                        <Col className={styles['rowDataContainer']} span={4}>
                          {typeof infoModulo.projetista.hasPermission === 'string' ? (
                            <div
                              className={
                                infoModulo.projetista.marked
                                  ? styles['rowDataMarked']
                                  : styles['rowDataUnMarked']
                              }
                            >
                              {t(infoModulo.projetista.hasPermission as string)}
                            </div>
                          ) : (
                            <>
                              {infoModulo.projetista.hasPermission === true ? (
                                <Icon
                                  icon={'confirmar'}
                                  className={
                                    infoModulo.projetista.marked
                                      ? styles['rowIconMarked']
                                      : styles['rowIconUnMarked']
                                  }
                                  customSize={12}
                                />
                              ) : (
                                <Icon
                                  icon={'cancelar'}
                                  className={
                                    infoModulo.projetista.marked
                                      ? styles['rowIconMarked']
                                      : styles['rowIconUnMarked']
                                  }
                                  customSize={12}
                                />
                              )}
                            </>
                          )}
                        </Col>
                        <Col className={styles['rowDataContainer']} span={4}>
                          {typeof infoModulo.engenheiro.hasPermission === 'string' ? (
                            <div
                              className={
                                infoModulo.engenheiro.marked
                                  ? styles['rowDataMarked']
                                  : styles['rowDataUnMarked']
                              }
                            >
                              {t(infoModulo.engenheiro.hasPermission as string)}
                            </div>
                          ) : (
                            <>
                              {infoModulo.engenheiro.hasPermission === true ? (
                                <Icon
                                  icon={'confirmar'}
                                  className={
                                    infoModulo.engenheiro.marked
                                      ? styles['rowIconMarked']
                                      : styles['rowIconUnMarked']
                                  }
                                  customSize={12}
                                />
                              ) : (
                                <Icon
                                  icon={'cancelar'}
                                  className={
                                    infoModulo.engenheiro.marked
                                      ? styles['rowIconMarked']
                                      : styles['rowIconUnMarked']
                                  }
                                  customSize={12}
                                />
                              )}
                            </>
                          )}
                        </Col>
                        <Col className={styles['rowDataContainer']} span={4}>
                          {typeof infoModulo.consultor.hasPermission === 'string' ? (
                            <div
                              className={
                                infoModulo.consultor.marked
                                  ? styles['rowDataMarked']
                                  : styles['rowDataUnMarked']
                              }
                            >
                              {t(infoModulo.consultor.hasPermission as string)}
                            </div>
                          ) : (
                            <>
                              {infoModulo.consultor.hasPermission === true ? (
                                <Icon
                                  icon={'confirmar'}
                                  className={
                                    infoModulo.consultor.marked
                                      ? styles['rowIconMarked']
                                      : styles['rowIconUnMarked']
                                  }
                                  customSize={12}
                                />
                              ) : (
                                <Icon
                                  icon={'cancelar'}
                                  className={
                                    infoModulo.consultor.marked
                                      ? styles['rowIconMarked']
                                      : styles['rowIconUnMarked']
                                  }
                                  customSize={12}
                                />
                              )}
                            </>
                          )}
                        </Col>
                      </Row>
                    ))}
                  </Panel>
                </Collapse>
              </div>
            ))}
          </>
        </div>
      </PageHeader>
    </div>
  );
};

const mapState = (state: IGlobalReducerState) => ({
  ...state.obra,
  ...state.auth,
  isLoading: state.tenant.isLoading,
  tenantRoles: [...(state.tenant.TenantRoles || [])],
  TenantSharedUsers: [...(state.tenant.Users || [])],
  minhaConta: state.minhaConta.userInfo,
  UsersWithConstruction: state.tenant.UsersWithConstruction
});

const connector = connect(mapState);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;

export default connector(PapeisPermissoes);
